import { render, staticRenderFns } from "./AppCustomizer.vue?vue&type=template&id=52667d36&scoped=true&"
import script from "./AppCustomizer.vue?vue&type=script&lang=js&"
export * from "./AppCustomizer.vue?vue&type=script&lang=js&"
import style0 from "./AppCustomizer.vue?vue&type=style&index=0&id=52667d36&lang=scss&"
import style1 from "./AppCustomizer.vue?vue&type=style&index=1&id=52667d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52667d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52667d36')) {
      api.createRecord('52667d36', component.options)
    } else {
      api.reload('52667d36', component.options)
    }
    module.hot.accept("./AppCustomizer.vue?vue&type=template&id=52667d36&scoped=true&", function () {
      api.rerender('52667d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/@core/layouts/components/app-customizer/AppCustomizer.vue"
export default component.exports